import { MapType } from "../enum/map-type";

export const MapTypeDetails = {
    [MapType.AUTO] : {
        Label: 'AUTO',
        Value: MapType.AUTO
    },
    [MapType.MANUAL] : {
        Label: 'MANUAL',
        Value: MapType.MANUAL
    }
}